import { executePost } from "../../../Utils/ServiceMethods";
import { toast } from "react-toastify";
import { SessionTimeout } from "../../../Utils/ErrorMessages";
import { removeUserCredentials } from "../../../Utils/LocalStorage";

export const GetMarketplaceBusinessListApi = async (payload, cb) => {
  try {
    const response = await executePost(
      "/get-marketplace-business-list",
      payload,
    );

    return response.data;
  } catch (error) {
    if (error?.response?.data?.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });

      removeUserCredentials();

      if (cb) cb();
    } else {
      return false;
    }
  }
};
